<ng-container *transloco="let t; prefix: 'property-upload-wizard'">
  <div class="container flex flex-1 flex-col rfs:gap-28 items-center mb-4">
    <progress-stepper class="progress-stepper-onboarding" [StepNo]="4" [Steps]="Steps"></progress-stepper>

    <div class="container flex flex-1 flex-col rfs:gap-28 items-center">
      <div class="flex flex-col gap-12 items-center justify-center">
        <div class="flex flex-col gap-4">
          <h2 class="h2 rfs:text-[40px] text-center font-semibold text-black">
            Διάλεξε το πακέτο που σου ταιριάζει
          </h2>
          <p class="rfs:text-xl text-center font-light">
            Δες τις διαθέσιμες επιλογές πακέτων και επίλεξε αυτό που σε
            εξυπηρετεί καλύτερα.
          </p>
        </div>
      </div>

      <form [formGroup]="form">
        <product-card [products]="this.productSelection" (onProductSelect)="onProductChange($event)"></product-card>
      </form>
    </div>
  </div>
  <app-property-upload-navigation [NextDisabled]="!this.selectedProduct" [HidePrevious]="false"
    (NextButtonClicked)="saveStep()"
    (PreviousButtonClicked)="previousButtonClicked.emit()"></app-property-upload-navigation>
</ng-container>